import "./sidebarRight.scss";

export default function SidebarRight({ show, size = "normal", children }) {
  return (
    <div className={`right-sidebar ${show ? "show" : "hide"} ${size}`}>
      {children}
    </div>
  );
}
